import {checkQueue} from "../../checkQueue";
import axios from "axios";

document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#withdrawalModal form');

    if (form !== null) {
        const block = form.querySelector('#submit-withdrawal-form').parentNode;

        block.addEventListener('click', async (e) => {
            const button = e.target.closest('button');

            if (!button || !block.contains(button)) return;

            e.preventDefault();

            const formData = new FormData(form);
            formData.set('step', 2);

            try {
                const response = await axios.post(form.action, Object.fromEntries(formData));

                checkQueue(
                    form.action.replace('/withdrawal', '/withdrawal-is-ready'), block, 'POST', formData);
            } catch (e) {
                console.error(e);
                return false;
            }
        })

        checkQueue(form.action.replace('/withdrawal', '/withdrawal-is-ready'), block, 'POST', new FormData(form));
    }
});